import { Component } from "@angular/core";
import { ApicallService } from "@core-services/apicall.service";
import { InfoService } from "@core-services/info.service";
import { UserService } from "@main-services/user.service";
import { Security2FAModalComponent } from "../../models/interfaces/security-2fa-modal.component";
import { Security2FAEnableModalComponent } from "../enable-modal/security-2fa-enable-modal.component";
import { TWO_FA_DISABLING_STEPS } from "@helpers/constants";
import { ConfirmModalService } from "@core-services/confirm-modal.service";
import { NewProfileFacade } from "@modules/main/components/profile/new-profile/state/new-profile.facade";

@Component({
	templateUrl: "./security-2fa-disable-modal.component.html",
	styleUrls: ["./security-2fa-disable-modal.component.scss"],
	standalone: false
})
export class Security2FADisableModalComponent extends Security2FAModalComponent {
	public readonly steps: number = TWO_FA_DISABLING_STEPS;

	public currentStep: number = 1;

	public constructor(
		protected userService: UserService,
		protected apicallService: ApicallService,
		protected infoService: InfoService,
		protected profileFacade: NewProfileFacade,
		protected confirmModalService: ConfirmModalService
	) {
		super(userService, apicallService, infoService, profileFacade, confirmModalService);
	}

	public onClickContinue(): void {
		this.cdr.markForCheck();
		switch (this.currentStep) {
			case 1:
				this.verifyUserPassword(true);
				break;
			case 2:
				this.verifySmsCode(true);
				break;
			case 3:
				this.closeAll();
				break;
			default:
				break;
		}
	}

	public onClickReEnable(): void {
		this.closeAll();
		this.modalService.create(Security2FAEnableModalComponent).present();
	}
}
